import type { App } from 'vue';

import { vRole } from '../directives/role';

export const roleDirective = {
  install(app: App) {
    app.directive('role', vRole);
  },
};
